export enum Representations {
  Club = "CLUB",
  State = "STATE",
  Region = "REGION",
  Country = "COUNTRY",
  Person = "PERSON",
}
